import React from "react";
import {Route} from "react-router-dom";
import {List, Create, Update, Show, ListDemo} from "../../views/marketplace/retailer/index";
import RequireAuthentication from "../../hoc/authentication/requireAuthentication";
import RetailerLoader from "../../hoc/retailer/retailerLoader";
import RetailerUnloader from "../../hoc/retailer/retailerUnloader";
import PhysicalEntryHandler from "../../hoc/notification/physicalEntryHandler";
import {Authorizations, hasAuthorization} from "../../utils/authorizations";
import {sessionStore} from "../../utils/sessionStore";
import {getMemberRetailers} from "../../actions/authentificationMember";

let routes = [];
const applications = sessionStore.get("applications");
const retailers = getMemberRetailers();
const authorizations = sessionStore.get("authorizations") ?? [];

if (applications && applications["marketplace"]) {
    if (null === retailers && hasAuthorization(authorizations, Authorizations.MARKETPLACE_RETAILER_MANAGEMENT)) {
        routes.push([
            <Route
                path="/retailers/create"
                component={RequireAuthentication(RetailerUnloader(Create))}
                exact
                key="create"
            />,
            <Route
                path="/retailers/edit/:id"
                component={RequireAuthentication(RetailerUnloader(Update))}
                exact
                key="update"
            />,
        ])
    }

    if (null === retailers || hasAuthorization(authorizations, Authorizations.MARKETPLACE_RETAILER_MANAGEMENT) || hasAuthorization(authorizations, Authorizations.MARKETPLACE_RETAILER_VIEW)) {
        routes.push([
            <Route
                path="/retailers/show/:id"
                component={RequireAuthentication(RetailerLoader(PhysicalEntryHandler(Show)))}
                exact
                key="show"
            />,
        ])
    }

    if ((null !== retailers && retailers?.length >= 1) || hasAuthorization(authorizations, Authorizations.MARKETPLACE_RETAILER_MANAGEMENT)) {
        if (hasAuthorization(authorizations, Authorizations.GLOBAL_DEMO)) {
            routes.push([  <Route
                path="/retailers/:params"
                component={RequireAuthentication(RetailerUnloader(ListDemo))}
                exact
                strict
                key="list"
            />])
        } else {
            routes.push([ <Route
                path="/retailers/:params"
                component={RequireAuthentication(RetailerUnloader(List))}
                exact
                strict
                key="list"
            />])
        }
        routes.push([
            <Route
                path="/retailers/show/:id"
                component={RequireAuthentication(RetailerLoader(PhysicalEntryHandler(Show)))}
                exact
                key="show"
            />,
        ])
    }
}

export default routes;
